export default __webpack_public_path__ + "static/media/ic_add_plus.e7b1c864.svg";